import { render, staticRenderFns } from "./TermsFirstLoginModal.vue?vue&type=template&id=aa6d3b64&scoped=true&"
import script from "./TermsFirstLoginModal.vue?vue&type=script&lang=js&"
export * from "./TermsFirstLoginModal.vue?vue&type=script&lang=js&"
import style0 from "./TermsFirstLoginModal.vue?vue&type=style&index=0&id=aa6d3b64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6d3b64",
  null
  
)

export default component.exports